var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSubscription(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.01 6.00977H20.01V8.00977H4.01V6.00977ZM6.01 2.00977H18.01V4.00977H6.01V2.00977ZM20 9.99977H4C3.46957 9.99977 2.96086 10.2105 2.58579 10.5856C2.21071 10.9606 2 11.4693 2 11.9998V19.9998C2 20.5302 2.21071 21.0389 2.58579 21.414C2.96086 21.7891 3.46957 21.9998 4 21.9998H20C20.5304 21.9998 21.0391 21.7891 21.4142 21.414C21.7893 21.0389 22 20.5302 22 19.9998V11.9998C22 11.4693 21.7893 10.9606 21.4142 10.5856C21.0391 10.2105 20.5304 9.99977 20 9.99977ZM10.3 19.9998L7 16.7598L8.4 15.3598L10.3 17.2598L15.6 11.9598L17 13.3598L10.3 19.9998Z",
    fill: "#17423C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSubscription);
export default __webpack_public_path__ + "static/media/subscription.9ed81aee1f5ec6036411b3a77bd60872.svg";
export { ForwardRef as ReactComponent };